export default __webpack_public_path__ + "static/media/c2.44797269.svg";